// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__vGbnS","col":"CardReaderDesc_col__3RCQD","label":"CardReaderDesc_label__11c18"};